<template>
	<div class="users">
		<a-form-model :model="setting" :rules="rules" layout="vertical" @submit="save_data" ref="setting_form">
			<a-divider orientation="left">
				废料价格（元/吨）
			</a-divider>
			<a-col :span="8"  v-for="(item, index) in setting.fl" :key="index">
				<a-form-model-item :ref="item.en_title" :prop="item.en_title" :label="item.title">
					<a-input-number style="width: 200px" :step="0.01" :precision="2" v-model="setting.res[item.en_title]" />
				</a-form-model-item>
			</a-col>
			<a-divider orientation="left">
				梯次价格（元/度）宁德时代
			</a-divider>
			<a-col :span="8"  v-for="(item, index) in setting.tcnd" :key="index">
				<a-form-model-item :ref="item.en_title" :prop="item.en_title" :label="item.title">
					<a-input-number style="width: 200px" :step="0.01" :precision="2" v-model="setting.res[item.en_title]" />
				</a-form-model-item>
			</a-col>
			<a-divider orientation="left">
				梯次价格（元/度）非宁德时代
			</a-divider>
			<a-col :span="8"  v-for="(item, index) in setting.tcndn" :key="index">
				<a-form-model-item :ref="item.en_title" :prop="item.en_title" :label="item.title">
					<a-input-number style="width: 200px" :step="0.01" :precision="2" v-model="setting.res[item.en_title]" />
				</a-form-model-item>
			</a-col>
			<a-divider orientation="left">
				其他参数
			</a-divider>
			<a-col :span="8"  v-for="(item, index) in setting.qt" :key="index">
				<a-form-model-item :ref="item.en_title" :prop="item.en_title" :label="item.title">
					<a-input-number style="width: 200px" :step="0.01" :precision="2" v-model="setting.res[item.en_title]" />
				</a-form-model-item>
			</a-col>
			<a-divider orientation="left">
			</a-divider>
			<div>
				<a-button type="primary" html-type="submit">
					修改
				</a-button>
			</div>
		</a-form-model>
	</div>
</template>

<script>
	import Func from '../../common/func'
	export default {
		name: 'Setting',
		data() {
			return {
				form: this.$form.createForm(this),
				setting: {
					res:{},
					fl:{},
					tcnd:{},
					tcndn:{},
					qt:{},
				},
				rules: {}
			}
		},
		created() {
			this.get_data();
		},
		methods: {
			get_data() {
				Func.url_get({
					action: 'setting_car.find_data'
				}, (res) => {
					if (res.error === 0) {
						this.setting = res.info;
						console.log(11);
						console.log(this.setting.res.fl_LFP);
					} else {
						this.$message.error(res.info);
					}
				});
			},
			save_data(e) {
				e.preventDefault();
				this.$refs.setting_form.validate(valid => {
					if (valid) {
						Func.url_post({
							action: 'setting_car.save_data',
							...this.setting.res
						}, (res) => {
							if (res.error === 0) {
								this.$message.success(res.info);
								this.add_model = false;
								this.get_data();
							} else {
								this.$message.error(res.info);
							}
						});
					} else {
						return false;
					}
				});
			},
			goto_url(url, user_no) {
				this.$router.push({
					path: '/users/' + url,
					params: {
						user_no: user_no
					}
				});
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
			},
			onChange(editor) {
				console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
			},
		}
	}
</script>
<!-- <style src="@wangeditor/editor/dist/css/style.css"></style> -->
<style lang="scss">
</style>